import { useState } from 'react';
import { IconSend, IconCircleOff } from '@tabler/icons-react';
import { useT } from '@hana/i18n';
import { Button, Input, Modal, Textarea, useToast } from '@hana/ui';
import { AR_CUSTOMERS } from '../finance/fixtures';
import { mailOk, rcpMailBody, rcpMailSubject, rcpMailTo, type RcpRow } from './rcp';
import './bulkmail.i18n';
import s from './ar.module.css';

// Mint-AR › MODAL "Mail xác nhận đã nhận tiền". Chỉ đọc: Gửi mail báo toast "Chưa mở ghi ở bản này"; phiếu chưa duyệt thì chặn như board.
export function MailModal({ row, onClose }: { row: RcpRow | null; onClose: () => void }) {
  return row ? <Body key={row.no} row={row} onClose={onClose} /> : null;
}

function Body({ row, onClose }: { row: RcpRow; onClose: () => void }) {
  const toast = useToast();
  const t = useT();
  const cus = AR_CUSTOMERS.find((c) => c.customer === row.cus);
  const [to, setTo] = useState(rcpMailTo(cus?.contact));
  const [body, setBody] = useState(rcpMailBody(row));
  const [att, setAtt] = useState(true);
  const [tried, setTried] = useState(false);
  const bad = tried && !mailOk(to);
  const send = () => {
    if (!row.ap) { toast({ msg: t('ml.unapproved', { no: row.no }) }); return; }
    if (!mailOk(to)) { setTried(true); return; }
    onClose();
    toast({ msg: t('bm.noWrite') });
  };
  return (
    <Modal
      open
      onOpenChange={(o) => !o && onClose()}
      title={t('ml.title')}
      description={t('ml.from', { no: row.no })}
      footer={<><Button icon={<IconCircleOff size={16} aria-hidden="true" />} onClick={onClose}>{t('ml.cancel')}</Button><Button variant="primary" icon={<IconSend size={16} aria-hidden="true" />} onClick={send}>{t('ml.send')}</Button></>}
    >
      <div className={s.rcM}>
        <Input label={t('ml.to')} required value={to} error={bad ? t('ml.badTo') : undefined} onChange={(e) => setTo(e.target.value)} />
        <p className={s.lb}>{t('ml.cc', { sale: cus?.sale ?? 'DAVID' })} <b>{rcpMailSubject(row)}</b></p>
        <Textarea label={t('ml.body')} rows={6} value={body} onChange={(e) => setBody(e.target.value)} />
        <label className={s.lb}><input type="checkbox" checked={att} onChange={() => setAtt(!att)} /> {t('ml.attach')}</label>
        {!row.ap && <p className={s.lb}>{t('ml.warn')}</p>}
      </div>
    </Modal>
  );
}
